import { Link } from 'react-router-dom';
import { useBranding } from '../../contexts/BrandingContext';
import FooterLanguageSwitch from '../marketing/FooterLanguageSwitch';
import FooterThemeSwitch from '../marketing/FooterThemeSwitch';

export default function MarketingFooter() {
  const { branding } = useBranding();
  const isCustomBranded = branding.type !== null;

  return (
    <footer className="px-4 py-6 border-t border-gray-200">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} {isCustomBranded ? (branding.brandName || branding.name) : 'Seraclabs'}. All rights reserved.
            {!isCustomBranded && (
              <>
                {' · Built by '}
                <a
                  href="https://groei.studio"
                  target="_blank"
                  rel="noopener"
                  className="hover:text-gray-700 transition-colors"
                >
                  Studio Groei
                </a>
              </>
            )}
          </div>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/legal/privacy" className="text-gray-500 hover:text-gray-700 transition-colors">
              Privacy
            </Link>
            <Link to="/legal/terms" className="text-gray-500 hover:text-gray-700 transition-colors">
              Terms
            </Link>
            {!isCustomBranded && (
              <>
                <Link to="/legal/dpa" className="text-gray-500 hover:text-gray-700 transition-colors">
                  DPA
                </Link>
                <a
                  href="https://github.com/serac-labs/serac/blob/main/LICENSE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                  License
                </a>
              </>
            )}
            <a
              href="mailto:support@serac.build"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              Support
            </a>
            <FooterThemeSwitch />
            <FooterLanguageSwitch />
          </div>
        </div>
      </div>
    </footer>
  );
}
